module.exports = __webpack_public_path__ + "static/media/external_link.4ebb3410.svg";